import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { Control } from "react-hook-form";

type MiscellaneousToggleProps = {
  control: Control<any>;
};

const MiscellaneousToggle: React.FC<MiscellaneousToggleProps> = ({ control }) => {
  return (
    <FormField
      control={control}
      name="isMiscellaneous"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between space-x-3 space-y-0 rounded-md border p-3">
          <div className="space-y-0.5">
            <FormLabel>Muhtelif</FormLabel>
            <FormDescription className="text-xs">
              Belirli bir kişi ile ilişkilendirilmeyen masraflar için işaretleyin
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default MiscellaneousToggle; 